import { render, staticRenderFns } from "./quanqingAbout.vue?vue&type=template&id=576c6a5b&scoped=true"
import script from "./quanqingAbout.vue?vue&type=script&lang=js"
export * from "./quanqingAbout.vue?vue&type=script&lang=js"
import style0 from "./quanqingAbout.vue?vue&type=style&index=0&id=576c6a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c6a5b",
  null
  
)

export default component.exports